import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import styles from "./styles.scss";

function PendingStatus(_: Props) {
  const { t } = useTranslation();

  return (
    <p className={styles.pendingStatus}>
      {t("planzoneMembersPage.resources.pending")}
    </p>
  );
}

export { PendingStatus };
